import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { m } from 'framer-motion';
import { alpha, styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

const RootStyle = styled('div')(({ theme }) => ({
  right: 0,
  bottom: 0,
  zIndex: 99999,
  width: '100%',
  height: '100%',
  position: 'fixed',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
  gap: 16,
}));

const MESSAGES = [
  'Syncing latest data...',
  'Updating in real time...',
  'Fetching fresh records...',
  'Almost there, hang tight...',
  'Pulling the latest updates...',
  'Getting things ready for you...',
  'Loading your dashboard...',
];

LoadingScreen.propTypes = {
  isDashboard: PropTypes.bool,
};

export default function LoadingScreen({ isDashboard, ...other }) {
  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMsgIndex((prev) => (prev + 1) % MESSAGES.length);
    }, 2800);
    return () => clearInterval(interval);
  }, []);

  return (
    <RootStyle {...other}>
      {/* Spinner rings */}
      <Box sx={{ position: 'relative', width: 100, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box
          component={m.div}
          animate={{ rotate: 360 }}
          transition={{ duration: 2.4, ease: 'linear', repeat: Infinity }}
          sx={{
            width: 64, height: 64,
            borderRadius: '50%',
            border: (theme) => `3px solid transparent`,
            borderTopColor: 'primary.main',
            borderRightColor: 'primary.light',
            position: 'absolute',
          }}
        />
        <Box
          component={m.div}
          animate={{ rotate: -360 }}
          transition={{ duration: 2.4, ease: 'linear', repeat: Infinity }}
          sx={{
            width: 84, height: 84,
            borderRadius: '50%',
            border: (theme) => `2px solid transparent`,
            borderBottomColor: alpha('#378ADD', 0.4),
            borderLeftColor: alpha('#378ADD', 0.6),
            position: 'absolute',
          }}
        />
      </Box>

      {/* Animated message */}
      <m.div
        key={msgIndex}
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -6 }}
        transition={{ duration: 0.4 }}
      >
        <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
          {MESSAGES[msgIndex]}
        </Typography>
      </m.div>

      <Typography variant="caption" sx={{ color: 'text.disabled' }}>
        Please wait a moment
      </Typography>
    </RootStyle>
  );
}